import styled, { css } from 'styled-components';

import { shades } from '@pkg/components/DesignSystem/tokens/shades';
import { styledTypography } from '@pkg/primitives';

const textBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    text-align: center;
    letter-spacing: -0.02em;
`;

export const Title = styled.p`
    ${textBase};
    font-weight: 700;
    font-size: 35px;
    letter-spacing: -0.03em;
    line-height: 0.9;
`;

export const Text = styled.p`
    ${textBase};
    color: ${shades.primary.light['50']};
    span {
        color: #fff;
    }
`;

export const BoldText = styled.p`
    ${textBase};
    font-weight: 700;
`;

export const StepContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
`;

export const VisualiserHolder = styled.div`
    width: clamp(290px, 30vh, 350px);
    height: clamp(290px, 30vh, 350px);
    overflow: hidden;
    border-radius: 20px;
    border: 1px solid #fff;
`;
export const VisualiserVideo = styled.video`
    width: 100%;
    height: 100%;
`;
